const rszyRouter = [
    /**
     * 人事管理
     **/
    {
        path: '/rszy/dept',
        meta: { title: '部门管理' },
        component: () => import('@/views/rszy/dept'),
        used: true,
    },
    {
        path: '/rszy/staff',
        meta: { title: '员工管理' },
        component: () => import('@/views/rszy/staff'),
        used: true,
    },
]

export default rszyRouter
